module.exports = __webpack_public_path__ + "static/media/RUS.099f7a2c.svg";